document.addEventListener("DOMContentLoaded", () => {
  const tabNavs = document.querySelectorAll(".shelf-tabs__selector");
  const tabPanels = document.querySelectorAll(".shelf-tabs__panel");

  if (!tabNavs.length || !tabPanels.length) return;

  tabNavs.forEach((selector) => {
    selector.addEventListener("click", () => {
      const targetId = selector.dataset.tabTarget;

      tabNavs.forEach((btn) => {
        btn.classList.toggle("is-active", btn === selector);
        btn.setAttribute("aria-selected", btn === selector ? "true" : "false");
      });

      tabPanels.forEach((panel) => {
        panel.classList.toggle("is-active", panel.id === targetId);
      });
    });
  });
});
